module.exports = __webpack_public_path__ + "static/img/zhaocaimao.1ecaeb02.png";